import React from "react";

const SkeletonBox = ({ className }) => (
  <div className={`animate-pulse bg-gray-300 rounded ${className}`} />
);

const OrderDetailsSkeleton = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-6 p-6 bg-gray-50 min-h-screen">
      {/* Order Items Section */}
      <div className="flex-1 space-y-4">
        <div className="flex items-center space-x-3">
          <SkeletonBox className="w-6 h-6" />
          <SkeletonBox className="w-32 h-5" />
        </div>

        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-start bg-white p-4 rounded shadow">
            <SkeletonBox className="w-20 h-20 rounded" />
            <div className="ml-4 flex-1 space-y-2">
              <SkeletonBox className="w-32 h-4" />
              <SkeletonBox className="w-40 h-3" />
              <SkeletonBox className="w-24 h-3" />
              <SkeletonBox className="w-16 h-6 mt-2" />
            </div>
            <SkeletonBox className="w-16 h-6 ml-auto" />
          </div>
        ))}
      </div>

      {/* Right Side - Shipping Address & Order Summary */}
      <div className="w-full lg:w-80 space-y-6">
        {/* Shipping Address */}
        <div className="bg-white p-4 rounded shadow space-y-4">
          <SkeletonBox className="w-40 h-5" />
          <div className="space-y-2">
            <SkeletonBox className="w-32 h-4" />
            <SkeletonBox className="w-24 h-4" />
            <SkeletonBox className="w-full h-4" />
          </div>
        </div>

        {/* Order Summary */}
        <div className="bg-white p-4 rounded shadow space-y-4">
          <SkeletonBox className="w-32 h-5" />
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex justify-between">
              <SkeletonBox className="w-32 h-4" />
              <SkeletonBox className="w-16 h-4" />
            </div>
          ))}
          <div className="flex justify-between font-bold">
            <SkeletonBox className="w-24 h-5" />
            <SkeletonBox className="w-24 h-5" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsSkeleton;
